import React, { MouseEventHandler } from "react";
import { T } from "services/lang/LanguageService";
import useIsMobile from "hooks/useIsMobile";
import { DashboardLayoutType, IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import DashboardComponent from "../../group-component/GroupComponent";
import { ContextMenuItem } from "../interfaces";

interface HorizontalFlexLayoutProps {
  components: IDashboardComponent[];
  align?: string;
  justify?: string;
  layoutType: DashboardLayoutType;
  groupId: string;
  onContextMenu: MouseEventHandler<HTMLDivElement>;
  setCurrentContextMenuItems: (currentContextMenuItems: ContextMenuItem[]) => void;
}

const HorizontalFlexLayout = ({
  components,
  align,
  justify,
  layoutType,
  groupId,
  onContextMenu,
  setCurrentContextMenuItems,
}: HorizontalFlexLayoutProps) => {
  const isMobile = useIsMobile();

  const getComponentWidth = (component: IDashboardComponent) => {
    if (isMobile || component.type === "SEPARATOR") {
      return 12;
    }
    if (component.layout?.HORIZONTAL_FLEX?.width) {
      return component.layout.HORIZONTAL_FLEX.width;
    }
    if (component.layout?.GRID?.width) {
      return component.layout.GRID.width;
    }
    return 6;
  };

  const getComponentHeight = (component: IDashboardComponent) => {
    if (component.type === "NOT_SUPPORTED") {
      return "auto";
    }
    if (component.layout?.HORIZONTAL_FLEX?.height) {
      return component.layout.HORIZONTAL_FLEX.height;
    }
    if (component.layout?.GRID?.height) {
      return "auto";
    }
    return 550;
  };

  return (
    <div
      style={{ height: "100%" }}
      className={`w-full flex flex-row flex-wrap align-items-${align?.toLowerCase()} justify-content-${justify?.toLowerCase()}`}
    >
      {components?.length > 0 ? (
        components.map(component => (
          <div
            key={component.id}
            onContextMenu={onContextMenu}
            className={`w-${getComponentWidth(component)}`}
            style={{
              height: getComponentHeight(component),
            }}
          >
            <DashboardComponent
              groupId={groupId}
              componentId={component.id}
              component={component}
              layoutType={layoutType}
              setCurrentContextMenuItems={setCurrentContextMenuItems}
            />
          </div>
        ))
      ) : (
        <div className="pl-3">{T("error.group-has-no-components")}</div>
      )}
    </div>
  );
};

export default HorizontalFlexLayout;
